import { Link, isRouteErrorResponse, useRouteError } from 'react-router-dom'

/**
 * What a crashed page shows instead of React Router's developer screen. Most
 * likely cause in this app: the api answered with a shape the SPA didn't
 * expect (see docs/CONTRACT-GAPS.md). The details are kept for whoever debugs it.
 */
export function RouteError() {
  const err = useRouteError()
  const detail = isRouteErrorResponse(err) ? `${err.status} ${err.statusText}` : err instanceof Error ? err.message : String(err)
  if (import.meta.env.DEV) console.error(err)
  return (
    <div className="grid min-h-[60vh] place-items-center p-6">
      <div className="max-w-md text-center">
        <p className="text-sm font-medium text-critical-fg">
          <span aria-hidden>● </span>Something went wrong on this page
        </p>
        <h1 className="mt-1 text-xl font-semibold">This screen couldn&rsquo;t load</h1>
        <p className="mt-2 text-sm text-slate-600">Reloading usually fixes it. If it keeps happening, send this to support:</p>
        <code className="mt-3 block break-words rounded-lg bg-slate-100 px-3 py-2 text-left font-mono text-xs text-slate-700">{detail}</code>
        <div className="mt-5 flex justify-center gap-3">
          <button onClick={() => window.location.reload()} className="rounded-lg bg-blue-600 px-3.5 py-2 text-sm font-medium text-white hover:bg-blue-700">
            Reload
          </button>
          <Link to="/" className="rounded-lg border border-slate-300 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50">
            Go to dashboard
          </Link>
        </div>
      </div>
    </div>
  )
}
